<template>
  <InnerPageLayout>
    <HandlerAccessDenied :is-denied="isDenied">
      <TopBrandPanel
        :isLoading="isLoading"
        :isButtonDisabled="isButtonDenied"
        @create-brand="createBrand"
      ></TopBrandPanel>
      <div class="form-container">
        <BrandCreateForm
          :isLoading="isLoading"
          @set-loading="setLoading"
          ref="createFormRef"
        ></BrandCreateForm>
      </div>
    </HandlerAccessDenied>
  </InnerPageLayout>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { useAuthStore } from "@/store/auth/login";

import InnerPageLayout from "@/widgets/layouts/InnerPageLayout.vue";
import TopBrandPanel from "@/entities/dictionaries/brands/panels/TopBrandPanel.vue";
import BrandCreateForm from "@/entities/dictionaries/brands/forms/BrandCreateForm.vue";
import HandlerAccessDenied from "@/shared/base/HandlerAccessDenied.vue";

const isLoading = ref(false);
const createFormRef = ref(null);
const authStore = useAuthStore();

const createBrand = () => {
  if (createFormRef.value) createFormRef.value.createBrand();
};

const setLoading = (value: boolean) => {
  isLoading.value = value;
};

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(
    ["system:read", "system:edit"],
    ["dictionaries:read", "dictionaries:edit"]
  );
});

const isButtonDenied = computed(() => {
  return authStore.isDeniedForPermissions(
    ["system:edit"],
    ["dictionaries:edit"]
  );
});
</script>

<style lang="scss" scoped>
.form-container {
  position: relative;
  top: 77px;
  width: calc(100% - 316px);
}
</style>
